import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import ChatContent from "@/components/chat/chatContainer/ChatContent/ChatContent.vue";
import ChatTopBarNewChat from "../ChatTopBarNewChat/ChatTopBarNewChat.vue";
import ChatInputBar from "@/components/chat/chatContainer/ChatInputBar/ChatInputBar.vue";
import { useGetNewChatContainerProperties } from "./useGetNewChatContainerProperties";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewChatContainer',
  setup(__props) {

const {
  isNoMembers,
  style,
  data,
  addMember,
  removeMember,
  isBlockingTextShown,
  inputBar,
} = useGetNewChatContainerProperties();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["chat-wrapper", { isNoMembers: _unref(isNoMembers) }]),
    style: _normalizeStyle(_unref(style))
  }, [
    _createVNode(ChatTopBarNewChat, {
      ref: "searchBar",
      members: _unref(data).members,
      onAddMember: _unref(addMember),
      onRemoveMember: _unref(removeMember)
    }, null, 8, ["members", "onAddMember", "onRemoveMember"]),
    _createVNode(ChatContent, {
      messages: _unref(data).messages,
      "is-deleted": _unref(data).isDeleted,
      "blocking-status": _unref(data).blockingStatus,
      "user-name": _unref(data).userName
    }, null, 8, ["messages", "is-deleted", "blocking-status", "user-name"]),
    (!_unref(isBlockingTextShown))
      ? (_openBlock(), _createBlock(ChatInputBar, {
          key: 0,
          ref_key: "inputBar",
          ref: inputBar,
          members: _unref(data).members,
          "already-exists-chat-id": _unref(data).chatId,
          "new-chat": true
        }, null, 8, ["members", "already-exists-chat-id"]))
      : _createCommentVNode("", true)
  ], 6))
}
}

})